import React from 'react';

export default function Card({
  children,
  className = '',
  padding = true,
}: {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}) {
  return (
    <div
      className={`bg-white border border-gray-100 rounded-lg shadow-sm ${padding ? 'p-5' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <h3 className="text-[15px] font-black text-gray-900 tracking-tight">{title}</h3>
        {subtitle && <p className="text-[12px] text-gray-500 font-medium mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
